import React from "react";
import { useAccountPhoto } from "./useAccountPhoto.js";

/** The caller owns initials, identity labels, colors, rings, and decorations. */
export function PhotoOrInitials({ identity, photoUrl, initials, label, size = 26, style }) {
  const { photoSrc, onPhotoError } = useAccountPhoto(identity, photoUrl);
  return <span style={{
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    flexShrink: 0, ...style, width: size, height: size, borderRadius: "50%",
  }}>
    {photoSrc ? <img key={`${identity}:${photoSrc}`} src={photoSrc} alt={label}
      onError={onPhotoError} referrerPolicy="no-referrer"
      style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover" }} /> : initials}
  </span>;
}
